import { render, staticRenderFns } from "./PQR.vue?vue&type=template&id=30535cbd&scoped=true&"
import script from "./PQR.vue?vue&type=script&lang=js&"
export * from "./PQR.vue?vue&type=script&lang=js&"
import style0 from "./PQR.vue?vue&type=style&index=0&id=30535cbd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30535cbd",
  null
  
)

export default component.exports